<template>
  <el-card>
    <div slot="header">
      Alapadatok
    </div>
    <el-form
      ref="basicDataForm"
      :model="basicData"
      label-position="top"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Terméknév"
            prop="name"
          >
            <el-input
              v-model="basicData.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Státusz"
            prop="status"
          >
            <el-select
              v-model="basicData.status"
              style="width: 100%;"
            >
              <el-option
                label="Aktív"
                value="active"
              />
              <el-option
                label="Inaktív"
                value="inactive"
              />
              <el-option
                label="Kifutó"
                value="run-out"
              />
              <el-option
                label="Kifutó és inaktív"
                value="run-out-inactive"
              />
              <el-option
                label="Láthatatlan"
                value="hidden"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" v-if="false">
          <el-form-item
            label="Cikkszám"
            prop="bracode"
          >
            <el-input
              v-model="basicData.barcode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="false">
          <el-form-item label="IA kód">
            <el-input
              v-model="basicData.ia_code"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Kategória" v-if="categories">
            <el-cascader
              v-model="basicData.category_id"
              :options="categories"
              :props="{ checkStrictly: true, label: 'name', value: 'id', emitPath: false }"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Vámtarifaszám">
            <el-select
              ref="customsTariffNumberSelect"
              :value="basicData.customs_tariff_number_id"
              style="width: 100%;"
              filterable
              clearable
              :filter-method="query => customsTariffNumberQuery = query"
              :no-data-text="customsTariffNumberQuery ? 'Nincs találat' : 'Nincs adat'"
              @input="onCustomsTariffNumberInput"
              @visible-change="customsTariffNumberQuery = ''"
              @keydown.native.enter="onCustomsTariffNumberEnter"
            >
              <el-option
                v-for="customsTariffNumber in filteredCustomsTariffNumbers"
                :key="customsTariffNumber.id"
                :label="customsTariffNumber.value"
                :value="customsTariffNumber.id"
              />
              <!-- Static label: a changing label makes el-select reset the typed text -->
              <el-option
                v-if="showCreateCustomsTariffNumberOption"
                class="create-customs-tariff-number-option"
                :value="createCustomsTariffNumberOptionValue"
                label="+ Új vámtarifaszám"
                :disabled="!isCustomsTariffNumberQueryValid"
              >
                <div>+ Új vámtarifaszám: {{ customsTariffNumberQuery }}</div>
                <div
                  v-if="!isCustomsTariffNumberQueryValid"
                  class="create-customs-tariff-number-option__hint"
                >
                  Csak számokat tartalmazhat
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Szarmazási ország" prop="origin_country_id">
            <el-select
              v-model="basicData.origin_country_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="country in countries"
                :key="country.id"
                :label="country.name"
                :value="country.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Szavatosság nap" prop="usability_days">
            <el-input
              v-model.number="basicData.usability_days"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Kg / db">
            <el-input-localized-numeric
              v-model="basicData.weight"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="12"
        >
          <el-form-item label="Beszállítók" v-if="suppliers">
            <el-select
              v-model="basicData.suppliers"
              style="width: 100%;"
              filterable
              multiple
              value-key="id"
            >
              <el-option
                v-for="supplier in suppliers"
                :key="supplier.id"
                :label="`#${supplier.id} ${supplier.company.name}`"
                :value="supplier.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Leírás">
            <el-input
              v-model="basicData.description"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label=""
            prop="is_billable"
          >
            <el-checkbox
              v-model="basicData.is_billable"
            >
              Számlázandó
            </el-checkbox>
            <el-checkbox
              v-model="basicData.is_available_for_representatives"
            >
              Képviselő rendelheti
            </el-checkbox>
            <el-checkbox
              v-model="basicData.is_pos"
            >
              POS termék
            </el-checkbox>
            <el-checkbox
              v-model="basicData.is_promotion"
            >
              Promóciós termék
            </el-checkbox>
            <el-checkbox
                v-model="basicData.is_pallet"
            >
              Raklap
            </el-checkbox>
            <template v-if="$config('PIROS_MOGYOROS_ALLOWED')">
              <el-checkbox
                v-model="basicData.is_piros_mogyoros"
              >
                Piros Mogyorós termék
              </el-checkbox>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
const CREATE_CUSTOMS_TARIFF_NUMBER_OPTION_VALUE = '__create_customs_tariff_number__';

export default {
  props: ['product'],
  data() {
    let checkUsabilityDays = (rule, value, callback) => {
      if (!value) {
        return callback();
      }
      if (!Number.isInteger(value)) {
        callback(new Error('Mező csak számot tartalmazhat'));
      } else {
        callback();
      }
    };
    return {
      customsTariffNumberQuery: '',
      creatingCustomsTariffNumber: false,
      createCustomsTariffNumberOptionValue: CREATE_CUSTOMS_TARIFF_NUMBER_OPTION_VALUE,
      basicData: {
        ctn: {},
        category: {},
        suppliers: [],
        manufacturer: {},
        is_available_for_representatives: false,
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Név megadása kötelező',
            trigger: 'change'
          }
        ],
        usability_days: [
          { validator: checkUsabilityDays, trigger: 'change'}
        ]
      }
    };
  },
  computed: {
    customsTariffNumbers() {
      return this.$store.getters['customsTariffNumber/customsTariffNumbers'];
    },
    filteredCustomsTariffNumbers() {
      const query = this.customsTariffNumberQuery.toLowerCase();
      if (!query) {
        return this.customsTariffNumbers;
      }
      return this.customsTariffNumbers.filter(ctn => String(ctn.value).toLowerCase().includes(query));
    },
    canCreateCustomsTariffNumber() {
      const user = this.$store.getters['auth/user'];
      return !!user && user.permissions.includes('settings.customstariffnumber.create');
    },
    showCreateCustomsTariffNumberOption() {
      return this.canCreateCustomsTariffNumber
        && this.customsTariffNumberQuery !== ''
        && !this.customsTariffNumbers.some(ctn => String(ctn.value) === this.customsTariffNumberQuery);
    },
    // Same rule as the customs tariff number dialog under Lists
    isCustomsTariffNumberQueryValid() {
      const value = this.customsTariffNumberQuery;
      return !isNaN(parseFloat(value)) && /^\d*\.?\d*?$/.test(value);
    },
    manufacturers() {
      return this.$store.getters['manufacturer/manufacturers'];
    },
    suppliers() {
      return this.$store.getters['partner/suppliers'];
    },
    categories() {
      return this.$store.getters['productCategory/productCategories'];
    },
    supplierCategories() {
      return this.$store.getters['supplierCategory/supplierCategories'];
    },
    countries() {
      return this.$store.getters['country/countries'];
    },
  },
  watch: {
    product(newVal) {
      this.basicData = Object.assign({}, newVal);
      this.basicData.suppliers = newVal.suppliers.map(s => s.id);
    },
  },
  methods: {
    onCustomsTariffNumberInput(value) {
      if (value === CREATE_CUSTOMS_TARIFF_NUMBER_OPTION_VALUE) {
        this.createCustomsTariffNumber(this.customsTariffNumberQuery);
        return;
      }
      this.$set(this.basicData, 'customs_tariff_number_id', value);
    },
    // Enter without a highlighted option is not handled by el-select, so it creates the typed value
    onCustomsTariffNumberEnter() {
      const select = this.$refs.customsTariffNumberSelect;
      if (select.hoverIndex !== -1 || !this.showCreateCustomsTariffNumberOption || !this.isCustomsTariffNumberQueryValid) {
        return;
      }
      const value = this.customsTariffNumberQuery;
      select.blur();
      this.createCustomsTariffNumber(value);
    },
    async createCustomsTariffNumber(value) {
      if (this.creatingCustomsTariffNumber) {
        return;
      }
      this.creatingCustomsTariffNumber = true;
      try {
        const customsTariffNumber = await this.$store.dispatch('customsTariffNumber/add', { value });
        // Wait for the new el-option to render, otherwise el-select shows the raw id as label
        await this.$nextTick();
        this.$set(this.basicData, 'customs_tariff_number_id', customsTariffNumber.id);
      } catch (e) {
      }
      this.creatingCustomsTariffNumber = false;
    },
  },
};
</script>

<style scoped>
.create-customs-tariff-number-option {
  height: auto;
  line-height: 20px;
  padding-top: 7px;
  padding-bottom: 7px;
}

.create-customs-tariff-number-option__hint {
  font-size: 12px;
  color: #F56C6C;
}
</style>
